import { notify } from 'utils/reduxUtils';

export const types = {
  ACTION_MODAL_CLOSE: 'modules/materialListPage/ACTION_MODAL_CLOSE',
  ACTION_MODAL_OPEN: 'modules/materialListPage/ACTION_MODAL_OPEN',

  DELETE_SUPPLIER_MATERIAL_ERROR:
    'modules/materialListPage/DELETE_SUPPLIER_MATERIAL_ERROR',
  DELETE_SUPPLIER_MATERIAL_REQUEST:
    'modules/materialListPage/DELETE_SUPPLIER_MATERIAL_REQUEST',
  DELETE_SUPPLIER_MATERIAL_SUCCESS:
    'modules/materialListPage/DELETE_SUPPLIER_MATERIAL_SUCCESS',

  EXPAND_FOR_SEARCH: 'modules/materialListPage/EXPAND_FOR_SEARCH',

  EXCLUDED_MATERIAL_SELECTOR_DRAW_CLOSE:
    'modules/materialListPage/EXCLUDED_MATERIAL_SELECTOR_DRAW_CLOSE',
  EXCLUDED_MATERIAL_SELECTOR_DRAW_CLOSE_ALL:
    'modules/materialListPage/EXCLUDED_MATERIAL_SELECTOR_DRAW_CLOSE_ALL',
  EXCLUDED_MATERIAL_SELECTOR_DRAW_OPEN:
    'modules/materialListPage/EXCLUDED_MATERIAL_SELECTOR_DRAW_OPEN',

  RECEIVE_EXPANDED_CLASSES: 'modules/materialListPage/RECEIVE_EXPANDED_CLASSES',
  RECEIVE_EXPANDED_FAMILIES:
    'modules/materialListPage/RECEIVE_EXPANDED_FAMILIES',
  RECEIVE_EXPANDED_MATERIALS:
    'modules/materialListPage/RECEIVE_EXPANDED_MATERIALS',

  UPDATE_MATERIAL_SELECTOR_SETTINGS_ERROR:
    'modules/materialListPage/UPDATE_MATERIAL_SELECTOR_SETTINGS_ERROR',
  UPDATE_MATERIAL_SELECTOR_SETTINGS_REQUEST:
    'modules/materialListPage/UPDATE_MATERIAL_SELECTOR_SETTINGS_REQUEST',
  UPDATE_MATERIAL_SELECTOR_SETTINGS_SUCCESS:
    'modules/materialListPage/UPDATE_MATERIAL_SELECTOR_SETTINGS_SUCCESS',

  UPLOAD_SUPPLIER_MATERIALS_ERROR:
    'modules/materialListPage/UPLOAD_SUPPLIER_MATERIALS_ERROR',
  UPLOAD_SUPPLIER_MATERIALS_REQUEST:
    'modules/materialListPage/UPLOAD_SUPPLIER_MATERIALS_REQUEST',
  UPLOAD_SUPPLIER_MATERIALS_SUCCESS:
    'modules/materialListPage/UPLOAD_SUPPLIER_MATERIALS_SUCCESS',
};

export const materialListPage = {
  expandForSearch: ({ classId, familyId, materialId, supplierMaterialId }) => ({
    type: types.EXPAND_FOR_SEARCH,
    payload: { classId, familyId, materialId, supplierMaterialId },
  }),
  receiveExpandedClasses: ({ classIds }) => ({
    type: types.RECEIVE_EXPANDED_CLASSES,
    payload: { classIds },
  }),
  receiveExpandedFamilies: ({ familyIds }) => ({
    type: types.RECEIVE_EXPANDED_FAMILIES,
    payload: { familyIds },
  }),
  receiveExpandedMaterials: ({ materialIds }) => ({
    type: types.RECEIVE_EXPANDED_MATERIALS,
    payload: { materialIds },
  }),
};

export const actionModal = {
  open: ({ type }) => ({
    type: types.ACTION_MODAL_OPEN,
    payload: { type },
  }),
  close: () => ({
    type: types.ACTION_MODAL_CLOSE,
  }),
};

export const deleteSupplierMaterial = {
  request: ({ supplierMaterialId }) => ({
    type: types.DELETE_SUPPLIER_MATERIAL_REQUEST,
    payload: { supplierMaterialId },
  }),
  success: notify(
    () => ({
      type: types.DELETE_SUPPLIER_MATERIAL_SUCCESS,
    }),
    'Successfully Deleted Material',
  ),
  error: notify(
    (error) => ({
      type: types.DELETE_SUPPLIER_MATERIAL_ERROR,
      payload: error,
    }),
    'Failed to Delete Material',
  ),
};

export const uploadSupplierMaterials = {
  request: (payload) => ({
    type: types.UPLOAD_SUPPLIER_MATERIALS_REQUEST,
    payload: payload,
  }),
  success: notify(
    () => ({
      type: types.UPLOAD_SUPPLIER_MATERIALS_SUCCESS,
    }),
    'Successfully Updated Materials',
  ),
  error: notify(
    (error) => ({
      type: types.UPLOAD_SUPPLIER_MATERIALS_ERROR,
      payload: error,
    }),
    'Failed to Update Materials',
  ),
};

export const updateMaterialSelectorSettings = {
  request: (payload) => ({
    type: types.UPDATE_MATERIAL_SELECTOR_SETTINGS_REQUEST,
    payload: payload,
  }),
  success: notify(
    () => ({
      type: types.UPDATE_MATERIAL_SELECTOR_SETTINGS_SUCCESS,
    }),
    'Successfully Updated Settings',
  ),
  error: notify(
    (error) => ({
      type: types.UPDATE_MATERIAL_SELECTOR_SETTINGS_ERROR,
      payload: error,
    }),
    'Failed to Update Settings',
  ),
};

export const excludedMaterialDrawer = {
  open: ({ entityType }) => ({
    type: types.EXCLUDED_MATERIAL_SELECTOR_DRAW_OPEN,
    payload: { entityType },
  }),
  close: ({ entityType }) => ({
    type: types.EXCLUDED_MATERIAL_SELECTOR_DRAW_CLOSE,
    payload: { entityType },
  }),
  closeAll: () => ({
    type: types.EXCLUDED_MATERIAL_SELECTOR_DRAW_CLOSE_ALL,
  }),
};
